/* ==========================================================================
   Royal Care Professional — the rating row under the product title

   One job: decide whether the theme's own stars stay, or step aside for
   Judge.me's badge.

   This started as a CSS rule and CSS could not answer the question. The row
   holds two things — Judge.me's .jdgm-preview-badge and the theme's fallback
   stars — and only one should ever be visible.

   The obvious test, "has the badge got anything in it", is wrong. On a product
   with no reviews Judge.me fills the badge and then hides it with an inline
   style. To a selector that badge is full, so the fallback stood down, and the
   row rendered as nothing at all: no stars under the title on exactly the
   products that needed the invitation most.

   The right question is not what the badge contains but whether it is being
   seen, and offsetHeight is the only thing that actually knows. So the test is
   measured, and the observer re-measures whenever Judge.me touches the badge —
   which it does asynchronously, after this file has already run once.

   Fails safe in every direction: no script, a blocked app, a thrown error, and
   the theme's own stars are what is left on the page.
   ========================================================================== */

(function () {
  'use strict';

  if (window.RCRating) {
    window.RCRating.init();
    return;
  }

  function sync(row) {
    var badge = row.querySelector('.jdgm-preview-badge');
    var fallback = row.querySelector('[data-rc-rating-fallback]');
    if (!badge || !fallback) return;

    // Painted, and painted with stars in it. Either alone is not enough:
    // a hidden badge still holds its stars, and a visible one may be a
    // placeholder Judge.me has not filled yet.
    var showing = badge.offsetHeight > 0 && badge.querySelector('.jdgm-star') !== null;

    fallback.hidden = showing;
  }

  function watch(row) {
    if (row.dataset.rcRatingInit === 'true') return;
    row.dataset.rcRatingInit = 'true';

    sync(row);

    var badge = row.querySelector('.jdgm-preview-badge');
    if (!badge || typeof MutationObserver !== 'function') return;

    // childList for the markup Judge.me injects, attributes for the inline
    // display:none it adds on a product with no reviews.
    var observer = new MutationObserver(function () {
      sync(row);
    });

    observer.observe(badge, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    // A safety net for the case the observer never fires because Judge.me
    // replaced the node rather than mutating it.
    window.setTimeout(function () {
      sync(row);
    }, 2500);
  }

  function init() {
    var rows = document.querySelectorAll('[data-rc-rating]');
    Array.prototype.forEach.call(rows, watch);
  }

  window.RCRating = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders the block on every settings change.
  document.addEventListener('shopify:section:load', init);
})();
